import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// 📥 Importar páginas
import Registration from "./pages/Registration";
import Perfil from "./pages/Perfil";
import Predashboard from "./components/verificacionExitosa";
import Notificaciones from "./pages/NotificacionesPage";
import Resultados from "./pages/Resultados";
import PublicResultados from "./pages/PublicResultados";
import Usuarios from "./pages/Usuarios";
import TasksAdmin from "./pages/TasksAdmin";
import AdminScenathon from "./pages/AdminScenathon";
import PublicLayout from "./layouts/PublicLayout";
import MainLayout from "./Main/MainLayoud";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiesPolicy from "./pages/CookiesPolicy";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PathwayPage from "./pages/Pathways";
import ScenariosPage from "./pages/Scenarios";
import ComparisonPage from "./pages/Comparison";
import EthiopiaLanding from "./pages/EthiopiaLanding";

import { NotificationsProvider } from "./components/Notificaciones/NotificationsContext";

// 📥 Importar Auth
import { AuthProvider, useAuth } from "./auth/AuthContext";
import RequireAuth from "./auth/RequireAuth";
import RequireRole from "./auth/RequireRole"; // 🆕 NUEVO
import Chat from "./components/Chat";
import PublicHeader from "./components/PublicHeader";

import "./App.css";

function LayoutWrapper({ headerText }) {
  return <MainLayout headerText={headerText} />;
}

function AppShell() {
  const { login } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);

  const openLoginModal = () => {
    setLoginError("");
    setShowLoginModal(true);
  };

  const closeLoginModal = () => {
    setShowLoginModal(false);
    setLoginPassword("");
  };

  const handleLoginSubmit = async (event) => {
    event.preventDefault();
    if (!loginEmail.trim() || !loginPassword) return;

    setLoginError("");
    setLoginLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/login`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: loginEmail.trim().toLowerCase(),
            password: loginPassword,
          }),
        },
      );

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setLoginError(data?.error || "Unable to sign in. Please try again.");
        return;
      }

      login({
        token: data.token,
        refreshToken: data.refreshToken,
        user: data.user,
        csrfToken: data.csrfToken,
      });
      closeLoginModal();
    } catch (error) {
      console.error("Login error:", error);
      setLoginError("Server error. Please try again later.");
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <>
      <PublicHeader onOpenLogin={openLoginModal} />
      <Routes>
        <Route element={<PublicLayout openLoginModal={openLoginModal} />}>
          <Route path="/" element={<EthiopiaLanding />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/predashboard" element={<Predashboard />} />
          <Route path="/public-results" element={<PublicResultados />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacidad" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiesPolicy />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>

        <Route element={<RequireAuth />}>
          <Route element={<LayoutWrapper headerText="Profile" />}>
            <Route path="/perfil" element={<Perfil />} />
          </Route>
          <Route element={<LayoutWrapper headerText="Notifications" />}>
            <Route path="/notificaciones" element={<Notificaciones />} />
          </Route>
          <Route element={<LayoutWrapper headerText="AI Assistant" />}>
            <Route path="/ai-assistant" element={<Chat isFullPage={true} />} />
          </Route>
        </Route>

        <Route element={<RequireAuth />}>
          <Route element={<RequireRole requiredRoles="user" />}>
            <Route
              element={<LayoutWrapper headerText="Select or Create Pathway" />}
            >
              <Route path="/pathways" element={<PathwayPage />} />
            </Route>
            <Route element={<LayoutWrapper headerText="Create Scenarios" />}>
              <Route path="/scenarios" element={<ScenariosPage />} />
            </Route>
            <Route element={<LayoutWrapper headerText="Pathway Comparison" />}>
              <Route path="/comparison" element={<ComparisonPage />} />
            </Route>
            <Route element={<LayoutWrapper headerText="Results" />}>
              <Route path="/results" element={<Resultados />} />
            </Route>
          </Route>
        </Route>

        <Route element={<RequireAuth />}>
          <Route element={<RequireRole requiredRoles="admin" />}>
            <Route element={<LayoutWrapper headerText="Users" />}>
              <Route path="/users" element={<Usuarios />} />
            </Route>
            <Route element={<LayoutWrapper headerText="Tasks" />}>
              <Route path="/admin/tasks" element={<TasksAdmin />} />
            </Route>
            <Route element={<LayoutWrapper headerText="Admin PPL" />}>
              <Route path="/admin" element={<AdminScenathon />} />
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<div>Page not found</div>} />
      </Routes>

      {showLoginModal && (
        <div
          className="
      fixed inset-0 z-50
      flex items-center justify-center
      bg-[#07152d]/45
      px-4 py-6
      backdrop-blur-[4px]
    "
          role="dialog"
          aria-modal="true"
          onClick={closeLoginModal}
        >
          <div
            className="
        relative
        w-full max-w-[460px]
        overflow-hidden
        rounded-[28px]
        border border-white/70
        bg-[#fffef8]
        shadow-[0_28px_90px_rgba(7,21,45,0.22)]
      "
            onClick={(event) => event.stopPropagation()}
          >
            {/* ======================================================
          DECORATIVE BACKGROUND
          ====================================================== */}

            <div
              className="
          pointer-events-none
          absolute inset-0
          bg-[radial-gradient(circle_at_85%_0%,rgba(187,219,170,0.30),transparent_32%),radial-gradient(circle_at_0%_100%,rgba(255,239,163,0.22),transparent_34%)]
        "
            />

            {/* Top accent */}

            <div
              className="
          absolute left-0 top-0
          h-[4px] w-full
          bg-gradient-to-r
          from-[#08725b]
          via-[#478c35]
          to-[#C49A1F]
        "
            />

            {/* ======================================================
          CONTENT
          ====================================================== */}

            <div className="relative z-10 p-7 sm:p-8">
              {/* ====================================================
            HEADER
            ==================================================== */}

              <div className="flex items-start justify-between gap-5">
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    {/* Small icon */}

                    <div
                      className="
                  flex h-10 w-10
                  shrink-0
                  items-center justify-center
                  rounded-full
                  bg-[#eef5df]
                  text-[#08725b]
                "
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        className="h-5 w-5"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M4.5 20.25a7.5 7.5 0 0115 0"
                        />
                      </svg>
                    </div>

                    <p
                      className="
                  text-[11px]
                  font-bold
                  uppercase
                  tracking-[0.22em]
                  text-[#08725b]
                "
                    >
                      Public Policy Lab Ethiopia
                    </p>
                  </div>

                  <h2
                    className="
                mt-5
                text-[27px]
                font-black
                leading-[1.12]
                tracking-[-0.03em]
                text-[#07152d]
                sm:text-[30px]
              "
                  >
                    Welcome back
                  </h2>

                  <p
                    className="
                mt-2
                max-w-[350px]
                text-[14px]
                font-medium
                leading-[1.6]
                text-slate-500
              "
                  >
                    Sign in to access your dashboard and continue working with
                    your pathways and scenarios.
                  </p>
                </div>

                {/* Close */}

                <button
                  type="button"
                  onClick={closeLoginModal}
                  aria-label="Close login modal"
                  className="
              flex h-9 w-9
              shrink-0
              items-center justify-center
              rounded-full
              border border-slate-200
              bg-white/80
              text-[22px]
              font-light
              leading-none
              text-slate-400
              transition-all duration-200
              hover:border-slate-300
              hover:bg-white
              hover:text-slate-700
            "
                >
                  ×
                </button>
              </div>

              {/* ====================================================
            FORM
            ==================================================== */}

              <form className="mt-8 space-y-5" onSubmit={handleLoginSubmit}>
                {/* EMAIL */}

                <div>
                  <label
                    htmlFor="login-email"
                    className="
                block
                text-[13px]
                font-bold
                text-[#243447]
              "
                  >
                    Email address
                  </label>

                  <div className="relative mt-2">
                    <div
                      className="
                  pointer-events-none
                  absolute inset-y-0 left-0
                  flex items-center
                  pl-4
                  text-slate-400
                "
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        className="h-[18px] w-[18px]"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21.75 6.75v10.5A2.25 2.25 0 0119.5 19.5h-15a2.25 2.25 0 01-2.25-2.25V6.75"
                        />

                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 6l9 6 9-6"
                        />
                      </svg>
                    </div>

                    <input
                      id="login-email"
                      type="email"
                      value={loginEmail}
                      onChange={(e) => setLoginEmail(e.target.value)}
                      placeholder="you@example.com"
                      required
                      autoComplete="email"
                      className="
                  w-full
                  rounded-2xl
                  border border-slate-200
                  bg-white/80
                  py-[13px]
                  pl-11 pr-4
                  text-[14px]
                  font-medium
                  text-[#07152d]
                  outline-none
                  transition-all duration-200

                  placeholder:text-slate-400

                  hover:border-slate-300

                  focus:border-[#08725b]
                  focus:bg-white
                  focus:ring-[3px]
                  focus:ring-[#08725b]/10
                "
                    />
                  </div>
                </div>

                {/* PASSWORD */}

                <div>
                  <div className="flex items-center justify-between">
                    <label
                      htmlFor="login-password"
                      className="
                  block
                  text-[13px]
                  font-bold
                  text-[#243447]
                "
                    >
                      Password
                    </label>

                    <button
                      type="button"
                      className="
                  text-[12px]
                  font-bold
                  text-[#08725b]
                  transition
                  hover:text-[#06513d]
                  hover:underline
                  hover:underline-offset-2
                "
                      onClick={() => {
                        closeLoginModal();
                        window.location.href = "/forgot-password";
                      }}
                    >
                      Forgot password?
                    </button>
                  </div>

                  <div className="relative mt-2">
                    <div
                      className="
                  pointer-events-none
                  absolute inset-y-0 left-0
                  flex items-center
                  pl-4
                  text-slate-400
                "
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        className="h-[18px] w-[18px]"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M16.5 10.5V6.75a4.5 4.5 0 00-9 0v3.75"
                        />

                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5.25 10.5h13.5A2.25 2.25 0 0121 12.75v6A2.25 2.25 0 0118.75 21H5.25A2.25 2.25 0 013 18.75v-6a2.25 2.25 0 012.25-2.25z"
                        />
                      </svg>
                    </div>

                    <input
                      id="login-password"
                      type="password"
                      value={loginPassword}
                      onChange={(e) => setLoginPassword(e.target.value)}
                      placeholder="Enter your password"
                      required
                      autoComplete="current-password"
                      className="
                  w-full
                  rounded-2xl
                  border border-slate-200
                  bg-white/80
                  py-[13px]
                  pl-11 pr-4
                  text-[14px]
                  font-medium
                  text-[#07152d]
                  outline-none
                  transition-all duration-200

                  placeholder:text-slate-400

                  hover:border-slate-300

                  focus:border-[#08725b]
                  focus:bg-white
                  focus:ring-[3px]
                  focus:ring-[#08725b]/10
                "
                    />
                  </div>
                </div>

                {/* ====================================================
              ERROR
              ==================================================== */}

                {loginError && (
                  <div
                    className="
                flex items-start gap-3
                rounded-2xl
                border border-rose-100
                bg-rose-50/80
                px-4 py-3.5
                text-[13px]
                font-medium
                leading-relaxed
                text-rose-700
              "
                  >
                    <span
                      className="
                  mt-[1px]
                  flex h-5 w-5
                  shrink-0
                  items-center justify-center
                  rounded-full
                  bg-rose-100
                  text-[12px]
                  font-bold
                  text-rose-600
                "
                    >
                      !
                    </span>

                    <span>{loginError}</span>
                  </div>
                )}

                {/* ====================================================
              SIGN IN BUTTON
              ==================================================== */}

                <button
                  type="submit"
                  disabled={
                    !loginEmail.trim() || !loginPassword || loginLoading
                  }
                  className="
              inline-flex
              w-full
              items-center justify-center
              gap-2
              rounded-2xl
              bg-[#08725b]
              px-5 py-[14px]
              text-[14px]
              font-bold
              text-white
              shadow-[0_8px_20px_rgba(8,114,91,0.18)]
              transition-all duration-200

              hover:-translate-y-[1px]
              hover:bg-[#06614e]
              hover:shadow-[0_12px_24px_rgba(8,114,91,0.23)]

              active:translate-y-0

              disabled:cursor-not-allowed
              disabled:bg-slate-300
              disabled:shadow-none
              disabled:hover:translate-y-0
            "
                >
                  {loginLoading && (
                    <span
                      className="
                  h-4 w-4
                  animate-spin
                  rounded-full
                  border-2
                  border-white/40
                  border-t-white
                "
                    />
                  )}

                  {loginLoading ? "Signing in..." : "Sign in"}
                </button>
              </form>

              {/* ====================================================
            REGISTER SEPARATOR
            ==================================================== */}

              <div className="my-7 flex items-center gap-4">
                <div className="h-px flex-1 bg-slate-200" />

                <span
                  className="
              text-[11px]
              font-bold
              uppercase
              tracking-[0.14em]
              text-slate-400
            "
                >
                  New to PPL?
                </span>

                <div className="h-px flex-1 bg-slate-200" />
              </div>

              {/* ====================================================
            SIGN UP
            ==================================================== */}

              <button
                type="button"
                onClick={() => {
                  closeLoginModal();
                  window.location.href = "/registration";
                }}
                className="
            inline-flex
            w-full
            items-center justify-center
            rounded-2xl
            border border-[#08725b]/25
            bg-[#eef5df]/60
            px-5 py-[13px]
            text-[14px]
            font-bold
            text-[#08725b]
            transition-all duration-200

            hover:border-[#08725b]/40
            hover:bg-[#e5efd2]
          "
              >
                Create a new account
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <NotificationsProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </NotificationsProvider>
    </AuthProvider>
  );
}

export default App;
